import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from '@gs/fe-storybook-gasco';
import OnboardingStep from '../onboarding-step/OnboardingStep';
import Slide1 from '../../../assets/images/onboarding-1.svg';
import Slide2 from '../../../assets/images/onboarding-2.svg';
import Slide3 from '../../../assets/images/onboarding-3.svg';
import './OnboardingModal.css';

const OnboardingModal = ({ isVisible, onClose }) => {
  const navigate = useNavigate();
  const [activeSlide, setActiveSlide] = useState(0);

  const steps = [
    {
      image: Slide1,
      altText: 'Slide 1',
      description: 'Ingresa el número telefónico que utilizas actualmente.',
    },
    {
      image: Slide2,
      altText: 'Slide 2',
      description:
        'Ingresa el código de validación enviado a tu número de teléfono.',
    },
    {
      image: Slide3,
      altText: 'Slide 3',
      description:
        'Responde unas sencillas preguntas de validación de identidad y ¡listo!',
    },
  ];

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isVisible) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose, isVisible]);

  const handleNext = () => {
    setActiveSlide((prevSlide) => {
      const nextSlide = prevSlide + 1;
      if (nextSlide >= steps.length) {
        navigate('/validation');
        return prevSlide;
      }
      return nextSlide;
    });
  };

  const handleSkip = () => {
    navigate('/validation');
  };

  return (
    <Modal
      isOpen={isVisible}
      classNameContainer="modal-overlay"
      classNameContent="modal"
      isCloseOnOutsideClick={true}
      animation="fade"
      onClose={onClose}
    >
      <div
        className="modal-content"
        id="page-onboarding"
        data-page-id={`Onboarding${activeSlide + 1}`}
      >
        <div className="modal-body">
          <OnboardingStep
            image={steps[activeSlide].image}
            altText={steps[activeSlide].altText}
            description={steps[activeSlide].description}
          />
        </div>
        <div className="carousel-dots">
          {steps.map((_, index) => (
            <span
              key={index}
              className={`dot ${activeSlide === index ? "active" : ""}`}
              onClick={() => setActiveSlide(index)}
            ></span>
          ))}
        </div>
        <div className="onboarding-buttons">
          <button
            className="saltarButton"
            id={`onboarding${activeSlide + 1}_saltar`}
            onClick={handleSkip}
          >Saltar</button>
          <button
            className="siguienteButton"
            id={`onboarding${activeSlide + 1}_siguiente`}
            onClick={handleNext}
          >Siguiente</button>
        </div>
      </div>
    </Modal>
  );
};

export default OnboardingModal;
